import { getDeviceTimeZone, getUserTimeZoneUpdate } from '@griply/utils';
import { useCallback, useEffect, useRef } from 'react';
import { useAppForeground } from 'shared/hooks/use-app-foreground';
import { useUser } from 'shared/hooks/use-user';

import { useUpdateUserSettings } from './use-update-user-settings';

export const useSyncUserTimezone = (): void => {
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  const settingsRef = useRef(user?.settings);
  settingsRef.current = user?.settings;

  const uid = user?.uid;

  const sync = useCallback(() => {
    if (!uid) {
      return;
    }
    const update = getUserTimeZoneUpdate(
      settingsRef.current,
      getDeviceTimeZone(),
    );
    if (!update) {
      return;
    }
    updateUserSettings(update);
  }, [uid, updateUserSettings]);

  useAppForeground(sync);

  useEffect(() => {
    sync();
  }, [sync]);
};
